$(function() {
  // https://developer.snapappointments.com/bootstrap-select/options/
  var bootstrap_select_default_options = {
    liveSearch: true,
    liveSearchNormalize: true,
    // liveSearchStyle: 'startsWith',
    showTick: true,
    size: 'auto',
    styleBase: 'custom-select',
    style: '',
    width: '100%'
  };
  $('select.form-control').selectpicker(bootstrap_select_default_options);

  // https://getbootstrap.com/docs/4.6/components/popovers/#example-enable-popovers-everywhere
  $('[data-toggle="popover"]').popover();

  // Disable drag-and-drop files in all Trix editors.
  // https://blog.saeloun.com/2019/11/12/attachments-in-action-text-rails-6.html
  document.addEventListener('trix-file-accept', function(event) {
    event.preventDefault();
    // Or, only allow images to be attached:
    // const acceptedFileTypes = ['image/jpeg', 'image/png', 'image/gif']
    // if (!acceptedFileTypes.includes(event.file.type)) {
    //   event.attachment.remove();
    //   event.preventDefault()
    // }
  });
});
